
import React, { useState, useCallback, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Fuse from 'fuse.js';

import { Button, AutoCompleteField } from "../../../helpers"
import { getFullName, sortArrayOfObjectsInAlphabeticalOrder } from "../../../utils"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { manualAssignProcessLineItem } from "../../../services/api/processLineItems";
import { fetchProcessLineStatus } from "../../../services/redux/reducers/processLineStatus/processLineStatus";
import { updateInvoiceVerificationData } from "../../../services/redux/reducers/invoiceVerification/invoiceVerification";


const ManualAssignDialog = (props) => {
    const { sellerPIProcessLine, selectedInvoice,hideManualAssignPanel, setIsLoading, sellerPIPunch} = props

    const dispatch = useDispatch()

    const [userSuggestions, setUserSuggestions] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const processLineStatusData = useSelector(state => state.processLineStatus.processLineStatusData)
    const pIProcessLineStatues = processLineStatusData.filter(eachStatus => eachStatus.processLineId === 1)

    const userDetails = useSelector((state) => state.userDetails)
    let pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers

    useEffect (() => {
        dispatch(fetchProcessLineStatus())

    }, [])

    let filterOnlyCheckedInUsers = pIProcessLineStatues.filter(eachProcessLineStatus => sellerPIProcessLine.usersList.includes(eachProcessLineStatus.userId) && eachProcessLineStatus.currentStatus).map(eachStatus=> eachStatus.userId)
    filterOnlyCheckedInUsers = new Set(filterOnlyCheckedInUsers)

    let manualAssigneeUserList = pmCompanyUsers.reduce((acc, eachUser) => {
        if (filterOnlyCheckedInUsers.has(eachUser.userId)) {
            acc.push({
                ...eachUser,
                fullName: getFullName(eachUser.firstName, eachUser.lastName)
            })
        }
        return acc
    }, [])

    manualAssigneeUserList = sortArrayOfObjectsInAlphabeticalOrder(manualAssigneeUserList, "firstName")

    const userFuzzSearch = useCallback(new Fuse(manualAssigneeUserList, {
        keys: ['fullName'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.fullName.replace(/\s+/g, '')
        },
    }), [manualAssigneeUserList])

    const userSearchMethod = (event) => {
        if (event.query === "") {
            setUserSuggestions([...manualAssigneeUserList])
        }
        else {
            const searchResults = userFuzzSearch.search(event.query)
            const relatedUsers = searchResults.map(eachProduct => eachProduct.item)
            setUserSuggestions(relatedUsers)
        }
    }

    const handleUserChange = (e) => {
        setSelectedUser(e.target.value)
    }

    const updateAssignee = async () => {
        if (!selectedUser) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please select user.", life: 3000 }))
        }

        if (window.confirm('This invoice will be assigned for verification. Are you sure to continue?')) {
            const data = {
                assigneeId : selectedUser.userId,
                processLineId : sellerPIProcessLine.processLineId,
                linkDocId: selectedInvoice.sellerPIPunchId
            }

            setIsLoading(true)
            const response = await manualAssignProcessLineItem(data)
            setIsLoading(false)

            if (response.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: response.data.error }))
            } else {
                hideManualAssignPanel()
                const updatedSellerPIPunchData = sellerPIPunch.map(eachSellerPIPunch => {
                    if (eachSellerPIPunch.sellerPIPunchId === selectedInvoice.sellerPIPunchId) {
                        return {
                            ...eachSellerPIPunch,
                            processLineAssignee: selectedUser.fullName,
                            relatedPLItemAssigneeId: selectedUser.userId
                        }
                    }
                    return eachSellerPIPunch
                })
                dispatch(updateInvoiceVerificationData(updatedSellerPIPunchData))
                return dispatch(raiseToast({ severity: 'success', detail: "Assignee has been updated successfully" }))
            }
        }
    }

    return (
        <div className="p-2 mb-0">
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                    <AutoCompleteField labelText="Select User" field="fullName" value={selectedUser} searchMethod={userSearchMethod} suggestions={userSuggestions} onChange={handleUserChange} dropdown required />
                </div>
            </div>
            <div className="flex justify-content-end mt-2">
                <Button label="Submit" onClick={updateAssignee} />
            </div>
        </div>
    )
}

export default ManualAssignDialog